// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as Auth__Hooks from "./Auth__Hooks.res.js";
import * as Auth__Types from "./Auth__Types.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StringHelpers from "../../helpers/StringHelpers.res.js";
import * as RadioCardGroup from "../../resources/selection-and-input/RadioCardGroup.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function Auth__Elements$SelectShopFilter(props) {
  let onChange = props.onChange;
  let __truncateItemLabel = props.truncateItemLabel;
  let __hideLabel = props.hideLabel;
  let __disabledIds = props.disabledIds;
  let __variation = props.variation;
  let variation = __variation !== undefined ? __variation : "primary";
  let disabledIds = __disabledIds !== undefined ? __disabledIds : [];
  let hideLabel = __hideLabel !== undefined ? __hideLabel : false;
  let truncateItemLabel = __truncateItemLabel !== undefined ? __truncateItemLabel : false;
  let dispatch = Auth__Hooks.useDispatch();
  let shops = Auth__Hooks.useShops();
  let activeShop = Auth__Hooks.useActiveShop();
  let shopItems = shops.map(shop => ({
    TAG: "Option",
    key: shop.id,
    label: shop.name,
    value: shop.id,
    disabled: disabledIds.some(id => id === shop.id)
  }));
  let sections = [
    {
      items: [{
          TAG: "Option",
          key: "default",
          label: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
          value: undefined,
          exclusive: true
        }]
    },
    {
      items: shopItems,
      title: I18n.t("Shops")
    }
  ];
  let value = Stdlib_Option.map(Stdlib_Option.orElse(props.value, activeShop), shop => shop.id);
  let label = !hideLabel ? I18n.t("Shop") : undefined;
  let preset = variation === "primary" ? "filter" : ({
      NAME: "inputField",
      VAL: {
        required: false
      }
    });
  let renderValue = truncateItemLabel ? param => {
      let selectedItems = param.selectedItems;
      if (selectedItems.length === 1) {
        let match = selectedItems[0];
        if (match.TAG === "Option") {
          if (match.value !== undefined) {
            return JsxRuntime.jsx(TextStyle.make, {
              children: StringHelpers.truncateWithMiddleEllipsis(match.label, 17)
            });
          } else {
            return JsxRuntime.jsxs(InlineText.make, {
              children: [
                JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("Shop") + I18n.t(":") + " ",
                  variation: "normal"
                }),
                JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined)
                })
              ]
            });
          }
        }
      }
      return JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Select a shop")
      });
    } : undefined;
  return JsxRuntime.jsx(Inline.make, {
    children: JsxRuntime.jsx(Select.make, {
      label: label,
      preset: preset,
      renderValue: renderValue,
      sections: sections,
      value: {
        TAG: "Single",
        _0: value
      },
      onChange: change => {
        if (change.TAG === "Single") {
          let nextShopId = change._0;
          let nextShop = Stdlib_Option.flatMap(nextShopId, shopId => shops.find(shop => shop.id === shopId));
          Stdlib_Option.forEach(onChange, fn => fn(nextShop));
          return dispatch({
            TAG: "ActiveShopSet",
            _0: nextShop
          });
        }
      }
    }),
    grow: false
  });
}

let SelectShopFilter = {
  make: Auth__Elements$SelectShopFilter
};

function Auth__Elements$SelectSingleShopFilter(props) {
  let onChange = props.onChange;
  let __disabledIds = props.disabledIds;
  let disabledIds = __disabledIds !== undefined ? __disabledIds : [];
  let dispatch = Auth__Hooks.useDispatch();
  let shops = Auth__Hooks.useShops();
  let value = props.value.id;
  let shopItems = shops.map(shop => ({
    TAG: "Option",
    key: shop.id,
    label: shop.name,
    value: shop.id,
    disabled: disabledIds.some(id => id === shop.id)
  }));
  let sections = [{
      items: shopItems
    }];
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Shop"),
    preset: "filter",
    sections: sections,
    value: {
      TAG: "Single",
      _0: value
    },
    onChange: change => {
      if (change.TAG === "Single") {
        let nextActiveShopId = change._0;
        let nextActiveShop = shops.find(shop => shop.id === nextActiveShopId);
        if (nextActiveShop !== undefined) {
          Stdlib_Option.forEach(onChange, fn => fn(nextActiveShop));
        }
        return dispatch({
          TAG: "ActiveShopSet",
          _0: nextActiveShop
        });
      }
    }
  });
}

let SelectSingleShopFilter = {
  make: Auth__Elements$SelectSingleShopFilter
};

function Auth__Elements$InputSelectSingleShopField(props) {
  let onChange = props.onChange;
  let __disabledIds = props.disabledIds;
  let disabledIds = __disabledIds !== undefined ? __disabledIds : [];
  let dispatch = Auth__Hooks.useDispatch();
  let shops = Auth__Hooks.useShops();
  let onChange$1 = nextActiveShopId => {
    let nextActiveShop = shops.find(shop => shop.id === nextActiveShopId);
    if (nextActiveShop !== undefined) {
      Stdlib_Option.forEach(onChange, fn => fn(nextActiveShop));
    }
    dispatch({
      TAG: "ActiveShopSet",
      _0: nextActiveShop
    });
  };
  let value = props.value.id;
  if (shops.length <= 4) {
    let shopItems = shops.map(shop => ({
      value: shop.id,
      title: shop.name,
      illustrationSvg: JsxRuntime.jsx("img", {
        style: {
          height: "100%",
          width: "auto",
          objectFit: "contain"
        },
        alt: "",
        src: Illustration.storeSrc
      }),
      endElement: JsxRuntime.jsx(Auth__Types.ShopKind.Badge.make, {
        value: shop.kind,
        size: "normal"
      }),
      disabled: disabledIds.some(id => id === shop.id)
    }));
    return JsxRuntime.jsx(RadioCardGroup.make, {
      items: shopItems,
      value: value,
      onChange: onChange$1
    });
  }
  let shopItems$1 = shops.map(shop => ({
    TAG: "Option",
    key: shop.id,
    label: shop.name,
    value: shop.id,
    disabled: disabledIds.some(id => id === shop.id)
  }));
  let sections = [{
      items: shopItems$1
    }];
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Shop"),
    preset: {
      NAME: "inputField",
      VAL: {
        required: props.required
      }
    },
    renderItem: param => {
      let item = param.item;
      if (item.TAG !== "Option") {
        return null;
      }
      let value = item.value;
      let shop = shops.find(shop => shop.id === value);
      return JsxRuntime.jsxs(Inline.make, {
        children: [
          JsxRuntime.jsx("span", {
            children: item.label
          }),
          shop !== undefined ? JsxRuntime.jsx(Auth__Types.ShopKind.Badge.make, {
              value: shop.kind,
              size: "normal"
            }) : null
        ],
        space: "normal",
        align: "spaceBetween"
      });
    },
    sections: sections,
    value: {
      TAG: "Single",
      _0: value
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return onChange$1(change._0);
      }
    }
  });
}

let InputSelectSingleShopField = {
  make: Auth__Elements$InputSelectSingleShopField
};

let useDispatch = Auth__Hooks.useDispatch;

let useScope = Auth__Hooks.useScope;

let useShops = Auth__Hooks.useShops;

let useActiveShop = Auth__Hooks.useActiveShop;

export {
  useDispatch,
  useScope,
  useShops,
  useActiveShop,
  SelectShopFilter,
  SelectSingleShopFilter,
  InputSelectSingleShopField,
}
/* I18n Not a pure module */
